/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Relativeminagomany3Inputs */

const en_relativeminagomany3 = /** @type {(inputs: Relativeminagomany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} min ago`)
};

const pt_relativeminagomany3 = /** @type {(inputs: Relativeminagomany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`há ${i?.n} min`)
};

/**
* | output |
* | --- |
* | "{n} min ago" |
*
* @param {Relativeminagomany3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const relativeminagomany3 = /** @type {((inputs: Relativeminagomany3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relativeminagomany3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relativeminagomany3(inputs)
	return pt_relativeminagomany3(inputs)
});
export { relativeminagomany3 as "relativeMinAgoMany" }